import { getCookie } from 'cookies-next';

const MAX_RETRY_COUNT = 10;
const RETRY_INTERVAL = 100;

const waitForSetupCookie = async (
  WART: string,
  retryCount = 0
): Promise<boolean> => {
  if (retryCount >= MAX_RETRY_COUNT) return false;

  const currentWart = getCookie('WART');

  if (currentWart === WART) return true;

  await new Promise((resolve) => setTimeout(resolve, RETRY_INTERVAL));

  return waitForSetupCookie(WART, retryCount + 1);
};
export default waitForSetupCookie;
